/**
 * Generated by orval v8.1.0 🍺
 * Do not edit manually.
 * RepeatMD.PatientApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AchievementProgress,
  DisplayAnonymousStatelessShareUrl,
  DisplayPersonAnonymous,
  DisplayReferralLinkClaimEligibilityResponse,
  GetReferralCodeResult,
  PlatformShareInvite,
  ProblemDetails,
  ReferralModel,
  ReferredUserModel,
  TrackedSharedUrl
} from '.././model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Get information regarding a referral code
 */
export const getReferralCode = (
    referralCode: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<GetReferralCodeResult>(
      {url: `/api/v1/referral-codes/${referralCode}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetReferralCodeQueryKey = (referralCode: string,) => {
    return [
    `/api/v1/referral-codes/${referralCode}`
    ] as const;
    }

    
export const getGetReferralCodeQueryOptions = <TData = Awaited<ReturnType<typeof getReferralCode>>, TError = ErrorType<unknown>>(referralCode: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReferralCode>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReferralCodeQueryKey(referralCode);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReferralCode>>> = ({ signal }) => getReferralCode(referralCode, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(referralCode), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReferralCode>>, TError, TData> & { queryKey: QueryKey }
}

export type GetReferralCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getReferralCode>>>
export type GetReferralCodeQueryError = ErrorType<unknown>


/**
 * @summary Get information regarding a referral code
 */

export function useGetReferralCode<TData = Awaited<ReturnType<typeof getReferralCode>>, TError = ErrorType<unknown>>(
 referralCode: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReferralCode>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetReferralCodeQueryOptions(referralCode,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Generate a personal referral code for a person
 */
export const generatePersonalReferralCode = (
    personId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<string>(
      {url: `/api/v1/referral-codes/personal-code/${personId}`, method: 'POST', signal
    },
      options);
    }
  


export const getGeneratePersonalReferralCodeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generatePersonalReferralCode>>, TError,{personId: string}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof generatePersonalReferralCode>>, TError,{personId: string}, TContext> => {

const mutationKey = ['generatePersonalReferralCode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generatePersonalReferralCode>>, {personId: string}> = (props) => {
          const {personId} = props ?? {};

          return  generatePersonalReferralCode(personId,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type GeneratePersonalReferralCodeMutationResult = NonNullable<Awaited<ReturnType<typeof generatePersonalReferralCode>>>
    
    export type GeneratePersonalReferralCodeMutationError = ErrorType<unknown>

    /**
 * @summary Generate a personal referral code for a person
 */
export const useGeneratePersonalReferralCode = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generatePersonalReferralCode>>, TError,{personId: string}, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof generatePersonalReferralCode>>,
        TError,
        {personId: string},
        TContext
      > => {
      return useMutation(getGeneratePersonalReferralCodeMutationOptions(options));
    }
    /**
 * @summary Retrieve all share invite codes for a person
 */
export const retrievePlatformShareInvitesForPerson = (
    personId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<PlatformShareInvite[]>(
      {url: `/api/v1/referral-codes/personal-code/${personId}/share-invite`, method: 'GET', signal
    },
      options);
    }
  



export const getRetrievePlatformShareInvitesForPersonQueryKey = (personId: string,) => {
    return [
    `/api/v1/referral-codes/personal-code/${personId}/share-invite`
    ] as const;
    }

    
export const getRetrievePlatformShareInvitesForPersonQueryOptions = <TData = Awaited<ReturnType<typeof retrievePlatformShareInvitesForPerson>>, TError = ErrorType<unknown>>(personId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrievePlatformShareInvitesForPerson>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrievePlatformShareInvitesForPersonQueryKey(personId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrievePlatformShareInvitesForPerson>>> = ({ signal }) => retrievePlatformShareInvitesForPerson(personId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(personId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retrievePlatformShareInvitesForPerson>>, TError, TData> & { queryKey: QueryKey }
}

export type RetrievePlatformShareInvitesForPersonQueryResult = NonNullable<Awaited<ReturnType<typeof retrievePlatformShareInvitesForPerson>>>
export type RetrievePlatformShareInvitesForPersonQueryError = ErrorType<unknown>


/**
 * @summary Retrieve all share invite codes for a person
 */

export function useRetrievePlatformShareInvitesForPerson<TData = Awaited<ReturnType<typeof retrievePlatformShareInvitesForPerson>>, TError = ErrorType<unknown>>(
 personId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrievePlatformShareInvitesForPerson>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getRetrievePlatformShareInvitesForPersonQueryOptions(personId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Retrieve tracked stateless share URL for a person for a specific platform
 */
export const retrieveTrackedStatelessShareUrlForPersonForPlatform = (
    personId: string,
    platformId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<TrackedSharedUrl[]>(
      {url: `/api/v1/referral-codes/tracked/${personId}/stateless-url/${platformId}`, method: 'GET', signal
    },
      options);
    }
  



export const getRetrieveTrackedStatelessShareUrlForPersonForPlatformQueryKey = (personId: string,
    platformId: string,) => {
    return [
    `/api/v1/referral-codes/tracked/${personId}/stateless-url/${platformId}`
    ] as const;
    }

    
export const getRetrieveTrackedStatelessShareUrlForPersonForPlatformQueryOptions = <TData = Awaited<ReturnType<typeof retrieveTrackedStatelessShareUrlForPersonForPlatform>>, TError = ErrorType<unknown>>(personId: string,
    platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveTrackedStatelessShareUrlForPersonForPlatform>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrieveTrackedStatelessShareUrlForPersonForPlatformQueryKey(personId,platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveTrackedStatelessShareUrlForPersonForPlatform>>> = ({ signal }) => retrieveTrackedStatelessShareUrlForPersonForPlatform(personId,platformId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(personId && platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retrieveTrackedStatelessShareUrlForPersonForPlatform>>, TError, TData> & { queryKey: QueryKey }
}

export type RetrieveTrackedStatelessShareUrlForPersonForPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveTrackedStatelessShareUrlForPersonForPlatform>>>
export type RetrieveTrackedStatelessShareUrlForPersonForPlatformQueryError = ErrorType<unknown>


/**
 * @summary Retrieve tracked stateless share URL for a person for a specific platform
 */

export function useRetrieveTrackedStatelessShareUrlForPersonForPlatform<TData = Awaited<ReturnType<typeof retrieveTrackedStatelessShareUrlForPersonForPlatform>>, TError = ErrorType<unknown>>(
 personId: string,
    platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveTrackedStatelessShareUrlForPersonForPlatform>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getRetrieveTrackedStatelessShareUrlForPersonForPlatformQueryOptions(personId,platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Retrieve achievement progress for a person for a specific platform
 */
export const retrieveAchievementProgressForPersonForPlatform = (
    personId: string,
    platformId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<AchievementProgress>(
      {url: `/api/v1/referral-codes/achievement/${personId}/progress/${platformId}`, method: 'GET', signal
    },
      options);
    }
  



export const getRetrieveAchievementProgressForPersonForPlatformQueryKey = (personId: string,
    platformId: string,) => {
    return [
    `/api/v1/referral-codes/achievement/${personId}/progress/${platformId}`
    ] as const;
    }

    
export const getRetrieveAchievementProgressForPersonForPlatformQueryOptions = <TData = Awaited<ReturnType<typeof retrieveAchievementProgressForPersonForPlatform>>, TError = ErrorType<unknown>>(personId: string,
    platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveAchievementProgressForPersonForPlatform>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrieveAchievementProgressForPersonForPlatformQueryKey(personId,platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveAchievementProgressForPersonForPlatform>>> = ({ signal }) => retrieveAchievementProgressForPersonForPlatform(personId,platformId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(personId && platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retrieveAchievementProgressForPersonForPlatform>>, TError, TData> & { queryKey: QueryKey }
}

export type RetrieveAchievementProgressForPersonForPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveAchievementProgressForPersonForPlatform>>>
export type RetrieveAchievementProgressForPersonForPlatformQueryError = ErrorType<unknown>


/**
 * @summary Retrieve achievement progress for a person for a specific platform
 */

export function useRetrieveAchievementProgressForPersonForPlatform<TData = Awaited<ReturnType<typeof retrieveAchievementProgressForPersonForPlatform>>, TError = ErrorType<unknown>>(
 personId: string,
    platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveAchievementProgressForPersonForPlatform>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getRetrieveAchievementProgressForPersonForPlatformQueryOptions(personId,platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Generate a stateless share URL for a person for a specific platform share invite
returns: XXXX-XXXX-PPPP-NNNN-SSSSSSS
            
XXXX-XXXX = personal referral code
PPPP = platform code
NNNN = random alphanumeric code
SSSSSSS = checksum
 */
export const generatePlatformShareInviteForPerson = (
    personalReferralCode: string,
    platformShareInvite: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<string>(
      {url: `/api/v1/referral-codes/stateless-share-url/${personalReferralCode}/platform/${platformShareInvite}`, method: 'POST', signal
    },
      options);
    }
  


export const getGeneratePlatformShareInviteForPersonMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generatePlatformShareInviteForPerson>>, TError,{personalReferralCode: string;platformShareInvite: string}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof generatePlatformShareInviteForPerson>>, TError,{personalReferralCode: string;platformShareInvite: string}, TContext> => {

const mutationKey = ['generatePlatformShareInviteForPerson'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generatePlatformShareInviteForPerson>>, {personalReferralCode: string;platformShareInvite: string}> = (props) => {
          const {personalReferralCode,platformShareInvite} = props ?? {};

          return  generatePlatformShareInviteForPerson(personalReferralCode,platformShareInvite,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type GeneratePlatformShareInviteForPersonMutationResult = NonNullable<Awaited<ReturnType<typeof generatePlatformShareInviteForPerson>>>
    
    export type GeneratePlatformShareInviteForPersonMutationError = ErrorType<unknown>

    /**
 * @summary Generate a stateless share URL for a person for a specific platform share invite
returns: XXXX-XXXX-PPPP-NNNN-SSSSSSS
            
XXXX-XXXX = personal referral code
PPPP = platform code
NNNN = random alphanumeric code
SSSSSSS = checksum
 */
export const useGeneratePlatformShareInviteForPerson = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generatePlatformShareInviteForPerson>>, TError,{personalReferralCode: string;platformShareInvite: string}, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof generatePlatformShareInviteForPerson>>,
        TError,
        {personalReferralCode: string;platformShareInvite: string},
        TContext
      > => {
      return useMutation(getGeneratePlatformShareInviteForPersonMutationOptions(options));
    }
    /**
 * @summary Record a click on a stateless share URL given the pretty share token XXXX-XXXX-PPPP-NNNN-SSSSSSS
 */
export const retrieveStatelessShareUrlById = (
    statelessPrettyToken: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayAnonymousStatelessShareUrl>(
      {url: `/api/v1/referral-codes/stateless-share-url/${statelessPrettyToken}`, method: 'GET', signal
    },
      options);
    }
  



export const getRetrieveStatelessShareUrlByIdQueryKey = (statelessPrettyToken: string,) => {
    return [
    `/api/v1/referral-codes/stateless-share-url/${statelessPrettyToken}`
    ] as const;
    }

    
export const getRetrieveStatelessShareUrlByIdQueryOptions = <TData = Awaited<ReturnType<typeof retrieveStatelessShareUrlById>>, TError = ErrorType<ProblemDetails>>(statelessPrettyToken: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveStatelessShareUrlById>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrieveStatelessShareUrlByIdQueryKey(statelessPrettyToken);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveStatelessShareUrlById>>> = ({ signal }) => retrieveStatelessShareUrlById(statelessPrettyToken, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(statelessPrettyToken), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retrieveStatelessShareUrlById>>, TError, TData> & { queryKey: QueryKey }
}

export type RetrieveStatelessShareUrlByIdQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveStatelessShareUrlById>>>
export type RetrieveStatelessShareUrlByIdQueryError = ErrorType<ProblemDetails>


/**
 * @summary Record a click on a stateless share URL given the pretty share token XXXX-XXXX-PPPP-NNNN-SSSSSSS
 */

export function useRetrieveStatelessShareUrlById<TData = Awaited<ReturnType<typeof retrieveStatelessShareUrlById>>, TError = ErrorType<ProblemDetails>>(
 statelessPrettyToken: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveStatelessShareUrlById>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getRetrieveStatelessShareUrlByIdQueryOptions(statelessPrettyToken,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Records a click event for a stateless share URL identified by its pretty share token
 */
export const recordClickForPrettyShareToken = (
    prettyShareToken: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/referral-codes/stateless-share-url/${prettyShareToken}/record/click`, method: 'POST', signal
    },
      options);
    }
  


export const getRecordClickForPrettyShareTokenMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordClickForPrettyShareToken>>, TError,{prettyShareToken: string}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof recordClickForPrettyShareToken>>, TError,{prettyShareToken: string}, TContext> => {

const mutationKey = ['recordClickForPrettyShareToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordClickForPrettyShareToken>>, {prettyShareToken: string}> = (props) => {
          const {prettyShareToken} = props ?? {};

          return  recordClickForPrettyShareToken(prettyShareToken,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type RecordClickForPrettyShareTokenMutationResult = NonNullable<Awaited<ReturnType<typeof recordClickForPrettyShareToken>>>
    
    export type RecordClickForPrettyShareTokenMutationError = ErrorType<unknown>

    /**
 * @summary Records a click event for a stateless share URL identified by its pretty share token
 */
export const useRecordClickForPrettyShareToken = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordClickForPrettyShareToken>>, TError,{prettyShareToken: string}, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recordClickForPrettyShareToken>>,
        TError,
        {prettyShareToken: string},
        TContext
      > => {
      return useMutation(getRecordClickForPrettyShareTokenMutationOptions(options));
    }
    /**
 * @summary Whether the signed-in client can still claim a friend's referral link at their practice
 */
export const retrieveReferralLinkClaimEligibility = (
    
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayReferralLinkClaimEligibilityResponse>(
      {url: `/api/v1/referral-codes/stateless-share-url/claim-eligibility`, method: 'GET', signal
    },
      options);
    }
  



export const getRetrieveReferralLinkClaimEligibilityQueryKey = () => {
    return [
    `/api/v1/referral-codes/stateless-share-url/claim-eligibility`
    ] as const;
    }

    
export const getRetrieveReferralLinkClaimEligibilityQueryOptions = <TData = Awaited<ReturnType<typeof retrieveReferralLinkClaimEligibility>>, TError = ErrorType<ProblemDetails>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveReferralLinkClaimEligibility>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrieveReferralLinkClaimEligibilityQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveReferralLinkClaimEligibility>>> = ({ signal }) => retrieveReferralLinkClaimEligibility(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retrieveReferralLinkClaimEligibility>>, TError, TData> & { queryKey: QueryKey }
}

export type RetrieveReferralLinkClaimEligibilityQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveReferralLinkClaimEligibility>>>
export type RetrieveReferralLinkClaimEligibilityQueryError = ErrorType<ProblemDetails>


/**
 * @summary Whether the signed-in client can still claim a friend's referral link at their practice
 */

export function useRetrieveReferralLinkClaimEligibility<TData = Awaited<ReturnType<typeof retrieveReferralLinkClaimEligibility>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveReferralLinkClaimEligibility>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getRetrieveReferralLinkClaimEligibilityQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Set a stateless share URL for a person for a specific platform
 */
export const setsStatelessReferralCodeForPlatformForPerson = (
    personId: string,
    platformId: string,
    prettyShareToken: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/referral-codes/stateless-share-url/${personId}/platform/${platformId}/code/${prettyShareToken}`, method: 'POST', signal
    },
      options);
    }
  


export const getSetsStatelessReferralCodeForPlatformForPersonMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setsStatelessReferralCodeForPlatformForPerson>>, TError,{personId: string;platformId: string;prettyShareToken: string}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof setsStatelessReferralCodeForPlatformForPerson>>, TError,{personId: string;platformId: string;prettyShareToken: string}, TContext> => {

const mutationKey = ['setsStatelessReferralCodeForPlatformForPerson'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setsStatelessReferralCodeForPlatformForPerson>>, {personId: string;platformId: string;prettyShareToken: string}> = (props) => {
          const {personId,platformId,prettyShareToken} = props ?? {};

          return  setsStatelessReferralCodeForPlatformForPerson(personId,platformId,prettyShareToken,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SetsStatelessReferralCodeForPlatformForPersonMutationResult = NonNullable<Awaited<ReturnType<typeof setsStatelessReferralCodeForPlatformForPerson>>>
    
    export type SetsStatelessReferralCodeForPlatformForPersonMutationError = ErrorType<unknown>

    /**
 * @summary Set a stateless share URL for a person for a specific platform
 */
export const useSetsStatelessReferralCodeForPlatformForPerson = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setsStatelessReferralCodeForPlatformForPerson>>, TError,{personId: string;platformId: string;prettyShareToken: string}, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setsStatelessReferralCodeForPlatformForPerson>>,
        TError,
        {personId: string;platformId: string;prettyShareToken: string},
        TContext
      > => {
      return useMutation(getSetsStatelessReferralCodeForPlatformForPersonMutationOptions(options));
    }
    /**
 * @summary Retrieve person details from a stateless referral code without authentication
 */
export const retrievePersonByStatelessPrettyTokenAnonymous = (
    prettyShareToken: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayPersonAnonymous>(
      {url: `/api/v1/referral-codes/anonymous/stateless-share-url/${prettyShareToken}`, method: 'GET', signal
    },
      options);
    }
  



export const getRetrievePersonByStatelessPrettyTokenAnonymousQueryKey = (prettyShareToken: string,) => {
    return [
    `/api/v1/referral-codes/anonymous/stateless-share-url/${prettyShareToken}`
    ] as const;
    }

    
export const getRetrievePersonByStatelessPrettyTokenAnonymousQueryOptions = <TData = Awaited<ReturnType<typeof retrievePersonByStatelessPrettyTokenAnonymous>>, TError = ErrorType<unknown>>(prettyShareToken: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrievePersonByStatelessPrettyTokenAnonymous>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrievePersonByStatelessPrettyTokenAnonymousQueryKey(prettyShareToken);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrievePersonByStatelessPrettyTokenAnonymous>>> = ({ signal }) => retrievePersonByStatelessPrettyTokenAnonymous(prettyShareToken, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(prettyShareToken), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retrievePersonByStatelessPrettyTokenAnonymous>>, TError, TData> & { queryKey: QueryKey }
}

export type RetrievePersonByStatelessPrettyTokenAnonymousQueryResult = NonNullable<Awaited<ReturnType<typeof retrievePersonByStatelessPrettyTokenAnonymous>>>
export type RetrievePersonByStatelessPrettyTokenAnonymousQueryError = ErrorType<unknown>


/**
 * @summary Retrieve person details from a stateless referral code without authentication
 */

export function useRetrievePersonByStatelessPrettyTokenAnonymous<TData = Awaited<ReturnType<typeof retrievePersonByStatelessPrettyTokenAnonymous>>, TError = ErrorType<unknown>>(
 prettyShareToken: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrievePersonByStatelessPrettyTokenAnonymous>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getRetrievePersonByStatelessPrettyTokenAnonymousQueryOptions(prettyShareToken,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Adds a referral to the database, based on user information.
 */
export const referralReferUser = (
    referredUserModel: ReferredUserModel,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<ReferralModel>(
      {url: `/api/v1/referrals`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: referredUserModel, signal
    },
      options);
    }
  


export const getReferralReferUserMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof referralReferUser>>, TError,{data: ReferredUserModel}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof referralReferUser>>, TError,{data: ReferredUserModel}, TContext> => {

const mutationKey = ['referralReferUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof referralReferUser>>, {data: ReferredUserModel}> = (props) => {
          const {data} = props ?? {};

          return  referralReferUser(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ReferralReferUserMutationResult = NonNullable<Awaited<ReturnType<typeof referralReferUser>>>
    export type ReferralReferUserMutationBody = ReferredUserModel
    export type ReferralReferUserMutationError = ErrorType<void>

    /**
 * @summary Adds a referral to the database, based on user information.
 */
export const useReferralReferUser = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof referralReferUser>>, TError,{data: ReferredUserModel}, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof referralReferUser>>,
        TError,
        {data: ReferredUserModel},
        TContext
      > => {
      return useMutation(getReferralReferUserMutationOptions(options));
    }
    /**
 * @summary Adds a referral to the database, based on user information.
 */
export const getReferUserUrl = (
    platformUserId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<string>(
      {url: `/api/v1/referrals/url/${platformUserId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetReferUserUrlQueryKey = (platformUserId: string,) => {
    return [
    `/api/v1/referrals/url/${platformUserId}`
    ] as const;
    }

    
export const getGetReferUserUrlQueryOptions = <TData = Awaited<ReturnType<typeof getReferUserUrl>>, TError = ErrorType<void>>(platformUserId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReferUserUrl>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReferUserUrlQueryKey(platformUserId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReferUserUrl>>> = ({ signal }) => getReferUserUrl(platformUserId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformUserId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReferUserUrl>>, TError, TData> & { queryKey: QueryKey }
}

export type GetReferUserUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getReferUserUrl>>>
export type GetReferUserUrlQueryError = ErrorType<void>


/**
 * @summary Adds a referral to the database, based on user information.
 */

export function useGetReferUserUrl<TData = Awaited<ReturnType<typeof getReferUserUrl>>, TError = ErrorType<void>>(
 platformUserId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReferUserUrl>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetReferUserUrlQueryOptions(platformUserId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




